import type { Fund } from 'venn-api';
import fund from './fund';

/** Funds are considered with no returns when they return true for {@link itemHasNoReturns} */
const fundWithNoReturns = { ...fund, startRange: null, endRange: null, frequency: null };

export default fundWithNoReturns as unknown as Fund;
